'use client'

import React from 'react'

import { SpaceProps } from '../../themes'
import { Container, TextPosition } from './styles'

export interface EmptyProps extends SpaceProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Text position
   */
  textPosition?: TextPosition

  /**
   * Height in px
   */
  height?: number

  /**
   * Content
   */
  children?: React.ReactNode

  /**
   * Background image URL
   */
  backgroundImg?: string | { url: string; size?: number }
}

/**
 * Empty component
 */
export const Empty = ({
  textPosition = 'center',
  children,
  className,
  backgroundImg,
  height,
  ...spaceProps
}: EmptyProps) => {
  const backgroundImgUrl =
    typeof backgroundImg === 'string' ? backgroundImg : backgroundImg?.url
  const backgroundImgSize =
    typeof backgroundImg === 'string' ? undefined : backgroundImg?.size

  return (
    <Container
      textPosition={textPosition}
      className={className}
      backgroundImg={backgroundImgUrl}
      backgroundSize={backgroundImgSize}
      boxHeight={height}
      {...spaceProps}
    >
      {children}
    </Container>
  )
}
